import React from 'react';
import cx from 'classnames';

import { useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import { VehicleHubProgressBar } from '../ProgressBar/VehicleHubProgressBar';

import styles from '../QuestionBody/QuestionBody.module.scss';

type QuestionBodyAsideProps = {
  children?: React.ReactNode;
  className?: string;
  withoutProgressBar?: boolean;
};

export const QuestionBodyAside = ({ children, className, withoutProgressBar }: QuestionBodyAsideProps) => {
  const breakpoints = useBreakpoint();
  const tabletBreakpoint = breakpoints.maxWidth.breakpointTablet;

  if ((!children && withoutProgressBar) || tabletBreakpoint) {
    return null;
  }

  const renderContent = () => {
    if (withoutProgressBar) {
      return children;
    }

    return (
      <>
        <VehicleHubProgressBar className={cx(styles.progressBar, styles.withoutTranslate)} />
        {children}
      </>
    );
  };

  return <aside className={cx(
    className,
    styles.aside,
  )}>
    {renderContent()}
  </aside>;
};
